var _style, _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPerd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 238 216",
    style: {
      enableBackground: "new 0 0 238 216"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.lose0{fill:#39003C;}\n\t.lose1{fill:#F37E72;}\n\t.lose2{fill:#FDCBC7;}\n\t.lose3{fill:#F0ACAE;}\n\t.lose4{fill:#FFF4F4;}\n\t.lose5{fill:#E49195;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_17"
  }, /*#__PURE__*/React.createElement("path", {
    className: "lose0",
    d: "M205.9,111.4c0,47.5-38.5,86-86,86c-13.3,0-25.9-3-37.1-8.4c-0.6-0.3-1.1-0.5-1.7-0.8 c-3.6-1.8-7.1-3.9-10.5-6.3c-0.1,0-0.1-0.1-0.2-0.1c-10.6-7.4-19.4-17.2-25.7-28.5c-0.1-0.2-0.2-0.3-0.2-0.4 c-6.8-12.3-10.6-26.4-10.6-41.4c0-46.5,36.9-84.4,83-85.9c0.2,0,0.3,0,0.5,0c0.8,0,1.7,0,2.6,0c2.2,0,4.3,0.1,6.4,0.2 c0.8,0,1.5,0.1,2.2,0.2c0.6,0.1,1.2,0.1,1.8,0.2l0,0c0.6,0.1,1.2,0.2,1.9,0.2l0,0C173.9,32.3,205.9,68.1,205.9,111.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "lose1",
    d: "M119.9,205.4c-51.8,0-94-42.2-94-94s42.2-94,94-94s94,42.2,94,94S171.8,205.4,119.9,205.4z M119.9,25.4 c-47.4,0-86,38.6-86,86s38.6,86,86,86s86-38.6,86-86S167.4,25.4,119.9,25.4z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "lose2",
    d: "M200.8,136.7l-1.4,3.8l-0.7,1.8l-15.4-0.8l-24.2,3l-18.3,11.6l-25.7,7.8L82.8,189c-0.6-0.3-1.1-0.5-1.7-0.8 c-3.6-1.8-7.1-3.9-10.5-6.3c-0.1,0-0.1-0.1-0.2-0.1c-10.6-7.4-19.4-17.2-25.7-28.5c-0.1-0.2-0.2-0.3-0.2-0.4l8.5-6.3l9.7-11.2 l3.4-33.3l3.6-13.3l9.9-6.3l3-0.4l6.5,4.1l4.5,11.5l3.5,9.2l0.9-7.5l-1-4.8L94.7,83l5.1-0.8h0.8l3.1-0.2l6.2,6.5l2.6,19.3 l-1.2,21.3l2.5,4.3l-0.5-12l2.6-13.6l-0.6-14.6l-3.7-7.6l-3.7-4.1l4.5-2.4l0.9-0.2l6.9-1.7V59.7l-0.6-19.4l-2.2-14.8l-0.6-4 l-0.4-2.5l0.8-2.5l0.9-2.8h7.4l6.3,9.7l0.5,2.9l1.8,10.8l0.3,1.2l0,0l4.2,19.2v19.8l0.6,3.2l0.9,4.8l-0.6,28.4l8.2,9.7l9.3,2.1 l19.4-2.1l15.6,2.5l1.8,2.1L200.8,136.7z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "lose2",
    points: "94.7,83 98,99.5 97.1,107 93.6,97.8 89.1,86.3 82.6,82.2 90.5,81.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "lose2",
    points: "113.3,121.4 113.8,133.4 111,129.1 111.7,107.8 111.7,85.6 115.4,93.1 115.9,107.8  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "lose3",
    d: "M199.4,140.6l-0.7,1.8l-15.4-0.8l-24.2,3l-18.3,11.6l-25.7,7.8l-32.3,25c-0.6-0.3-1.1-0.5-1.7-0.8 c-3.6-1.8-7.1-3.9-10.5-6.3l5.5-6.9l8.2-12.4l-3.8-9l15.6,6.3l19-6.3l15.8-1.9l23.4-9.3l24.4-4.2L199.4,140.6z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "lose4",
    points: "193.6,128.1 185.9,127.3 169.3,130 158.3,133.4 145.9,133.4 136.2,122.8 133.9,106.4 139.1,80.6  140,85.4 139.4,113.8 147.6,123.5 156.8,125.6 176.2,123.5 191.8,126  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "lose4",
    points: "134.4,38.4 126.3,20.9 117.2,16.5 118.1,13.8 125.5,13.8 131.8,23.5 134.1,37.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "lose4",
    points: "98,99.5 97.1,107 93.6,97.8 89.1,86.3 82.6,82.2 90.5,81.1 94.7,83  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "lose4",
    points: "129.9,91.6 129,107 127.8,126.4 126.1,119 126.1,99.9 122.4,84.9 113.3,78.8 120.2,77.1 128.1,79.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "lose4",
    points: "111.7,85.6 111.7,107.8 109.6,88.9 103.7,82 107.4,81.8 108,81.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "lose3",
    points: "113.3,121.4 113.8,133.4 111,129.1 111.7,107.8 111.7,85.6 115.4,93.1 115.9,107.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "lose3",
    points: "97,94.6 100.1,103.1 101,118.2 99,130.9 101,136 97,130.7 97.1,107 98,99.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "lose3",
    points: "88.1,119 86.5,110.2 87.3,101 79.1,90.2 83.6,102.8 84.6,113.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "lose5",
    points: "79.1,90.2 75.8,102.4 81.1,111.8 83.6,119 92.8,124.7 94.9,134.8 106.2,141 115.9,139.7 126.4,132.7  118.4,136 113.8,133.4 111,129.1 111,135 104.9,137.4 101,136 97,130.7 97.1,107 95.6,118 91.6,120.7 88.1,119 84.6,113.6  83.6,102.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "lose3",
    points: "79.1,90.2 71.7,99.6 75.4,114.3 68.3,133.4 75.1,143.5 89.5,147.9 99,143.5 111,147.9 123.3,141  126.4,132.7 115.9,139.7 106.2,141 94.9,134.8 92.8,124.7 83.6,119 81.1,111.8 75.8,102.4  "
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPerd);
export default __webpack_public_path__ + "static/media/perd.7305baca3bae0b6b01d9819375bb856b.svg";
export { ForwardRef as ReactComponent };